var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "eSignModal",
    attrs: {
      id: "e-sign-modal",
      "header-close-button": !!_vm.eSignDisabled,
      "modal-footer": !_vm.loading,
      "modal-dialog-size": _vm.modalSize,
      "modal-dialog-scrollable": false,
      "modal-class": _vm.modalClass,
    },
    on: { show: _vm.handleShow, hidden: _vm.handleHidden },
    scopedSlots: _vm._u(
      [
        {
          key: "header",
          fn: function () {
            return [
              _vm._v("\n    " + _vm._s(_vm.modalTitle) + "\n    "),
              _c(
                "span",
                { attrs: { id: "e-sign-tooltip" } },
                [
                  _c("icon", {
                    staticClass: "tooltip-info",
                    attrs: { name: "question-circle" },
                  }),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "body",
          fn: function () {
            return [
              _c(
                "div",
                { attrs: { id: "e-sign-modal-wrapper" } },
                [
                  !_vm.eSignDisabled
                    ? _c("account-usage-banner", {
                        attrs: {
                          page: _vm.accountPlanPage,
                          "position-fixed": false,
                          "side-right": false,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("incident-message", {
                    attrs: { "service-name": "hellosign" },
                    on: { update: _vm.handleIncidentUpdate },
                  }),
                  _vm._v(" "),
                  _vm.loading
                    ? _c(_vm.currentLoaderComponent, { tag: "component" })
                    : [
                        _c(
                          _vm.currentPage,
                          _vm._b(
                            {
                              ref: "loadedComponent",
                              tag: "component",
                              on: {
                                "add-role": _vm.handleAddRole,
                                "delete-role": _vm.handleDeleteRole,
                                start: _vm.startPackageCreation,
                                change: _vm.handleDocumentsChange,
                                "select-all-documents":
                                  _vm.handleSelectAllDocuments,
                                "signers-change": _vm.handleSignersChange,
                                "select-template-document":
                                  _vm.handleDocumentTemplateSelect,
                                "delete-template-document":
                                  _vm.handleDocumentTemplateDelete,
                                "change-requester": _vm.handleRequesterChange,
                                "change-status": _vm.handleStatusChange,
                                remind: _vm.handleReminder,
                                complete: _vm.handleRequestComplete,
                                cancel: _vm.handleCancel,
                                error: _vm.handleFatalError,
                                "finish-template": _vm.handleFinishTemplate,
                                "template-select": _vm.handleSelectTemplate,
                                "template-delete": _vm.handleDeleteTemplate,
                                "template-edit": _vm.handleEditTemplate,
                                "update-prefix-appid":
                                  _vm.handleApplicationIdIncludeValue,
                                "next-step": _vm.nextStep,
                                valid: _vm.handleValid,
                              },
                            },
                            "component",
                            {
                              flow: _vm.flow,
                              steps: _vm.steps,
                              currentTemplateData: _vm.currentTemplateData,
                              signerRoles: _vm.currentTemplateData.signerRoles,
                              uploadingDocument: _vm.uploadingDocument,
                              selectedDocuments: _vm.selectedDocuments,
                              requestedData: _vm.requestedData.response,
                              signers: _vm.signers,
                              reminding: _vm.reminding,
                              templates: _vm.templates.byId,
                              clientApplicationRequests:
                                _vm.clientApplicationRequests.byId,
                              documents: _vm.availableDocuments.byId,
                              agentUsername: _vm.requesterUsername,
                            },
                            false
                          )
                        ),
                      ],
                ],
                2
              ),
            ]
          },
          proxy: true,
        },
        !_vm.loading
          ? {
              key: "footer",
              fn: function () {
                return [
                  !_vm.eSignDisabled
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "row justify-content-between" },
                          [
                            _vm.showControlButtons
                              ? [
                                  _vm.showSteps
                                    ? _c("div", { staticClass: "col-auto" }, [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-link btn-sm",
                                            on: { click: _vm.prevStep },
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  _vm.previousStepButtonText
                                                ) +
                                                "\n            "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-primary btn-sm ml-2",
                                            attrs: {
                                              disabled: !_vm.canContinue,
                                            },
                                            on: { click: _vm.nextStep },
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(_vm.nextStepButtonText) +
                                                "\n            "
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _c(
                                        "div",
                                        {
                                          staticClass:
                                            "select-flow-buttons-container col-auto",
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-white btn-sm",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleFlowChange(
                                                    "manageTemplates"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "e-sign-package.actions.manageTemplates"
                                                    )
                                                  ) +
                                                  "\n            "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "plan-simple-button",
                                            {
                                              attrs: {
                                                "class-name":
                                                  "btn btn-primary btn-sm ml-2",
                                                page: _vm.accountPlanPage,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleFlowChange(
                                                    "createESignPackage"
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n              " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "e-sign-package.actions.createESignPackage"
                                                    )
                                                  ) +
                                                  "\n            "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ])
                    : _vm._e(),
                ]
              },
              proxy: true,
            }
          : null,
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }